// storage 帮助类
import Storage from "utils/store";
const data = Storage.l_get("autocomplete");
//  自动补全
export const autoComplete = {
  name: "autoComplete",
  state: data || {},
  reducers: {
    // // 获取localStorage 里面的配置信息
    // getSett(state, data: any) {
    //   const _data = Storage.l_get(data.uuid);
    //   let storageInfo: any;
    //   if (_data) {
    //     for (let item in _data) {
    //       if (item === data.name) {
    //         storageInfo = _data[item];
    //         break;
    //       }
    //     }
    //   }

    //   let settInfo = {};
    //   settInfo[data.name] = storageInfo;

    //   return { ...state, ...settInfo };
    // },
    // 保存设置信息到LocalStorage中
    saveSett(state, data: any) {
      let _data = Storage.l_get("autocomplete");
      if (!_data) {
        _data = {};
      }

      // 去除数组中的重复数据
      function unique(array) {
        let n = {},
          r: any = [],
          val: any,
          type;
        for (let i = 0; i < array.length; i++) {
          val = array[i];
          type = typeof val;
          if (!n[val]) {
            n[val] = [type];
            r.push(val);
          } else if (n[val].indexOf(type) < 0) {
            n[val].push(type);
            r.push(val);
          }
        }
        return r;
      }

      const formData = _data[data.name];
      const settInfo = data.settInfo;
      const keys = Object.keys(settInfo);
      if (formData) {
        for (const item in formData) {
          if (
            keys.indexOf(item) > -1 &&
            settInfo[item] &&
            settInfo[item].length > 0
          ) {
            formData[item] = unique([
              ...formData[item],
              ...settInfo[item]
            ]).filter(item => {
              return item;
            });
          }
        }
      } else {
        _data[data.name] = data.settInfo;
      }

      Storage.l_set("autocomplete", _data);
      return { ...state, ..._data };
    }
  }
};
